import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { CountriesData, Country, CountryItem } from 'sections/Resources/FreightForwarder/data';
import { List } from 'sections/Resources/FreightForwarder/components/Countries/components/List';
import { ListItem } from 'sections/Resources/FreightForwarder/components/Countries/components/ListItem';
import { useSearchTerm } from 'sections/Resources/FreightForwarder/hooks/useSearchTerm';
import styles from 'sections/Resources/FreightForwarder/components/Countries/Countries.module.scss';

const cn = classNames.bind(styles);

const Countries = (): ReactElement => {
  const { foundTerms, isSearchActive } = useSearchTerm();

  const renderElements = () => {
    if (isSearchActive) {
      return foundTerms.map((item: CountryItem) => {
        return (
          <ListItem key={`${item.id}_${item.name}`} name={item.name} url={item.url}/>
        );
      });
    } else {
      return CountriesData.map((item: Country) => {
        if (!item.countries.length) return;
        return (
          <List
            key={item.id}
            id={item.id}
            region={item.region}
            countries={item.countries}
          />
        );
      });
    }
  };

  return (
    <div className={cn('countries__container')}>
      {renderElements()}
    </div>
  );
};

export { Countries };